export const OrderHistoryDetailsPageTemplate = {
    slots: ['SlbOrderHistoryDetailsSlot'],
};